import { z } from "zod";
export const MEMBER_INVITATION_STATUSES = ["pending", "accepted", "revoked", "expired"];
export const memberInvitationStatusSchema = z.enum(MEMBER_INVITATION_STATUSES);
export const MemberInvitationStatusEnum = {
    PENDING: "pending",
    ACCEPTED: "accepted",
    REVOKED: "revoked",
    EXPIRED: "expired",
};
